import { PriceDisplay, PageId, useSetPriceConfigs } from "@vp/price-platform";
import React, { useContext } from "react";

import { PageStaticDataContext } from "../../../contexts/PageStaticDataContextProvider";
import { ProductContext } from "../../../contexts/ProductContextProvider";
import { AnalyticsContext } from "../../../contexts/AnalyticsContextProvider";
import { analyticsPageData } from "../../../utils/analyticsConfig";
import PageConfig from "../../../utils/PageConfig";
import { BffDataContext } from "../../../contexts/BffDataContextProvider";

const PriceDisplayBuilder: React.FC = () => {
  const { locale, mpv } = useContext(PageStaticDataContext);
  const { selectedQuantity, selections } = useContext(ProductContext);
  const { analyticsPageName } = useContext(AnalyticsContext);
  const { compatibleQuantities } = useContext(BffDataContext);

  useSetPriceConfigs({
    locale: locale,
    tenant: PageConfig.tenant,
    tracking: {
      category: analyticsPageData.category,
      pageSection: analyticsPageData.pageSection,
      pageStage: analyticsPageData.pageStage,
      pageName: analyticsPageName(mpv.mpvId),
    },
    pageId: PageId.PDP,
  });

  return (
    <>
      <PriceDisplay
        productKey={mpv.coreProductId}
        version={mpv.version}
        quantity={selectedQuantity}
        selections={selections}
        cacheableQuantities={compatibleQuantities}
      />
    </>
  );
};

export default PriceDisplayBuilder;
